module.exports = __webpack_public_path__ + "static/img/digital-hainan.0c6441c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/digital-hainan.png
// module id = 6XjL
// module chunks = 1 2